<template>
  <div class="container">
    <van-nav-bar left-arrow @click-left="$router.back()" title="关注/粉丝"></van-nav-bar>
    <van-tabs v-model="active">
      <van-tab title="我的关注" name="follow">
        <InfiniteList :requestFn="getUserFollowList">
          <template #default="{row:item}">
            <div class="user-item">
              <van-image
                round
                width="1.33rem"
                height="1.33rem"
                :src="item.photo"
              ></van-image>
              <div class="info">
                <p>{{ item.name }}</p>
                <p>粉丝数：{{ item.fans_count }} 人</p>
              </div>
              <van-button
                round
                size="mini"
                @click="followFn(item)"
                :type="item.is_followed ? 'default' : 'danger'"
                >
                {{ item.is_followed ? (item.mutual_follow?"互相关注":"取消关注") : "关注" }}
              </van-button>
            </div>
          </template>
        </InfiniteList>
      </van-tab>
      <van-tab title="我的粉丝" name="fans">
        <InfiniteList :requestFn="getUserFansList">
          <template #default="{row:item}">
            <div class="user-item">
              <van-image
                round
                width="1.33rem"
                height="1.33rem"
                :src="item.photo"
              ></van-image>
              <div class="info">
                <p>{{ item.name }}</p>
                <p>粉丝数：{{ item.fans_count }} 人</p>
              </div>
              <van-button
                round
                size="mini"
                @click="followFn(item)"
                :type="item.mutual_follow ? 'default' : 'danger'"
                >
                {{ item.mutual_follow ? "互相关注" : "关注" }}
              </van-button>
            </div>
          </template>
        </InfiniteList>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import InfiniteList from './components/infinite-list'
import { getUserFansList, getUserFollowList, unFollowings, followings } from '@/api/user'
export default {
  name: 'UserFans',
  components: {
    InfiniteList
  },
  data () {
    return {
      active: null
    }
  },
  created () {
    this.active = this.$route.query.type || 'follow'
  },
  methods: {
    getUserFansList,
    async getUserFollowList (page, pageSize) {
      const data = await getUserFollowList(page, pageSize)
      data.results.forEach(item => {
        item.is_followed = true
      })
      return data
    },
    async followFn (item) {
      if (item.mutual_follow) {
        await unFollowings(item.id)
      } else {
        await followings(item.id)
      }
      item.mutual_follow = !item.mutual_follow
      this.$toast.success(item.mutual_follow ? '关注成功' : '取消关注')
    }
  }
}
</script>
<style scoped lang="less">
::v-deep .van-tab {
  flex: none;
  margin: 0 10px;
}
::v-deep .van-tabs__line {
  width: 28px;
}
  .user-item {
    height: 78px;
    display: flex;
    align-items: center;
    .van-image {
      margin-right: 10px;
    }
    .info {
      flex: 1;
      p {
        &:first-child {
          font-size: 16px;
        }
        &:last-child {
          color: #999;
        }
      }
    }
    .van-button {
      width: 64px;
      height: 30px;
    }
  }
/deep/ .van-button--default {
  background: #ebedf0;
  color: #A5A6AB;
}
</style>
